import { render } from "./collectionRecord.vue?vue&type=template&id=cf2d5ec4"
import script from "./collectionRecord.vue?vue&type=script&lang=js"
export * from "./collectionRecord.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__